import React, { useState } from "react"
import CreditMemoTypeIcon from "../../../../invoice/creditmemotypeicon.component"
import EditAndRefundCreditMemoModal from "../../../../invoice/editandrefundcreditmemomodal.component"
import GlobalHelper from "../../../GlobalHelper"

interface OwnProps {
    data:  {
        identifier: string,
        id: string,
        type: string,
    }
}

const CreditMemoEditModal = (props: OwnProps) => {

    const [openModal, setOpenModal] = useState<boolean>(false)

    const handleOpenModal = () => {
        setOpenModal(true)
    }
    
    const handleCloseModal = (objectId?: string, objectType?: string) => {
        setOpenModal(false)

        if (objectId && objectType) {
            window.location.href = GlobalHelper.getObjectEditPathByObjectType(objectId, objectType)
        }
    }
    
    return (
        <>
            {openModal && (
                <EditAndRefundCreditMemoModal
                    creditMemoId={props.data.id}
                    onClose={handleCloseModal}
                />
            )}
            <a key={"credit-memo-edit-modal-identifier-anchor"} href={"#"} onClick={handleOpenModal}>
                <CreditMemoTypeIcon value={props.data.type}/>
                {props.data.identifier}
            </a>

        </>
    )
}

export default CreditMemoEditModal


// WEBPACK FOOTER //
// ./src/common/listing/generic-listing/edit-modals/CreditMemoEditModal.tsx